var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "bg-secondary-3 p-4" },
    [
      _c(
        "div",
        { staticClass: "d-flex" },
        [
          _c("icon-view", {
            staticClass: "mt-5 mb-3 mt-md-0 mt-sm-5",
            attrs: {
              gradient: false,
              icon: "file-circle-plus-icon",
              "icon-background": "#ff7058",
              "icon-color": "white",
              "icon-size": "14px",
              title: "Añadir Documento"
            }
          })
        ],
        1
      ),
      _c("validation-observer", { ref: "formObserver" }, [
        _c("div", { staticClass: "row p-2" }, [
          _c(
            "div",
            { staticClass: "col-md-6" },
            [
              _c("validation-provider", {
                attrs: { rules: "required" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function({ errors }) {
                      return [
                        _c("custom-drop-down", {
                          staticClass: "w-100",
                          attrs: {
                            "custom-error-msg":
                              "Favor seleccionar documento a añadir.",
                            error: errors[0],
                            fieldkey: "id",
                            fieldname: "displayName",
                            label: "Nombre del Documento:",
                            options: _vm.documentTypes,
                            placeholder:
                              "Escriba un nombre existente de un documento"
                          },
                          on: {
                            input: function($event) {
                              return _vm.onDocumentTypeChange()
                            }
                          },
                          model: {
                            value: _vm.model.document,
                            callback: function($$v) {
                              _vm.$set(_vm.model, "document", $$v)
                            },
                            expression: "model.document"
                          }
                        })
                      ]
                    }
                  }
                ])
              })
            ],
            1
          ),
          _vm.isOther
            ? _c(
                "div",
                { staticClass: "col-md-6" },
                [
                  _c("validation-provider", {
                    attrs: { rules: "required" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function({ errors }) {
                            return [
                              _c("custom-input", {
                                attrs: {
                                  "custom-error-msg":
                                    "Favor especificar el nombre del documento a añadir.",
                                  error: errors[0],
                                  label: "Especifique Nombre del Documento:",
                                  type: "text"
                                },
                                model: {
                                  value: _vm.model.otherDocumentName,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.model,
                                      "otherDocumentName",
                                      $$v
                                    )
                                  },
                                  expression: "model.otherDocumentName"
                                }
                              })
                            ]
                          }
                        }
                      ],
                      null,
                      false,
                      3128357374
                    )
                  })
                ],
                1
              )
            : _vm._e()
        ]),
        _c("div", { staticClass: "row p-2" }, [
          _c(
            "div",
            { staticClass: "col-md-12" },
            [
              _c("custom-text-area", {
                attrs: {
                  disabled: !_vm.isOther,
                  label: "Descripción:",
                  maxlength: 250,
                  name: "description",
                  rows: 3
                },
                model: {
                  value: _vm.model.description,
                  callback: function($$v) {
                    _vm.$set(_vm.model, "description", $$v)
                  },
                  expression: "model.description"
                }
              })
            ],
            1
          )
        ]),
        _c("div", { staticClass: "row p-2" }, [
          _c(
            "div",
            { staticClass: "col-md-4" },
            [
              _c("div", { staticClass: "color-secondary-6 font-14" }, [
                _vm._v(" Requerido?: ")
              ]),
              _c("validation-provider", {
                attrs: { rules: "required" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function({ errors }) {
                      return [
                        _c("custom-radio", {
                          staticClass: "custom-radio__extended",
                          attrs: {
                            id: "isRequiredRb",
                            "custom-error-msg":
                              "Favor indicar si documento será requerido.",
                            error: Boolean(errors[0]),
                            "is-inline": "",
                            name: "isRequiredRb",
                            options: _vm.requiredOptions
                          },
                          model: {
                            value: _vm.model.required,
                            callback: function($$v) {
                              _vm.$set(_vm.model, "required", $$v)
                            },
                            expression: "model.required"
                          }
                        })
                      ]
                    }
                  }
                ])
              })
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "col-md-4" },
            [
              _c("div", { staticClass: "color-secondary-6 font-14" }, [
                _vm._v(" Aplica a Proveedor: ")
              ]),
              _c("validation-provider", {
                attrs: { rules: "required" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function({ errors }) {
                      return [
                        _c("custom-radio", {
                          staticClass: "custom-radio__extended",
                          attrs: {
                            id: "providerApplicationRb",
                            "custom-error-msg":
                              "Favor seleccionar a que tipo de proveedor aplica el documento.",
                            error: Boolean(errors[0]),
                            "is-inline": "",
                            name: "providerApplicationRb",
                            options: _vm.applicationProviderOptions
                          },
                          model: {
                            value: _vm.model.providerApplication,
                            callback: function($$v) {
                              _vm.$set(_vm.model, "providerApplication", $$v)
                            },
                            expression: "model.providerApplication"
                          }
                        })
                      ]
                    }
                  }
                ])
              })
            ],
            1
          )
        ]),
        _c(
          "div",
          { staticClass: "d-flex justify-content-end mt-3" },
          [
            _c("action-button", {
              attrs: {
                i: "fas fa-times-circle",
                text: "Cancelar",
                variant: "outline-danger mr-3 pl-3 pr-4"
              },
              on: { click: _vm.onCancelHandler }
            }),
            _c("action-button", {
              attrs: {
                i: "fas fa-save",
                text: "Guardar",
                variant: "success pl-3 pr-3"
              },
              on: { click: _vm.onSaveHandler }
            })
          ],
          1
        )
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }